import React, { useEffect, useState } from 'react';

// styling
import { Spacing } from '_styles';

// utils
import { getTaskCardStatus, getJobStatusColor } from "_utils/functions";

// redux
import { useSelector } from "react-redux";
import { selectAirportLocations } from '_redux/slices/timeline/timeline-areas';

const JobStatus = (props) => {

    // redux
    const airportLocations = useSelector(selectAirportLocations);

    // states
    const [jobStatusLine, setJobStatusLine] = useState("");                                             // status of job    
    const [locationColor, setLocationColor] = useState('green');                                                  // checked in status

    useEffect(() => {

        // check if the job has an rejectedPax change it's status to Rejected
        const isRejectedArrJourney = props?.job?.originalBookingDoc?.paxRejection?.find((paxRejection) => paxRejection?.type === "arrivalJourney");
        const isRejectedDepJourney = props?.job?.paxRejection?.find((paxRejection) => paxRejection?.type === "preBoardJourney");
        const isRejectedArrPax = props?.job?.originalBookingDoc?.paxRejection?.find((paxRejection) => paxRejection?.type === "arrivalPax");
        const isRejectedDepPax = props?.job?.paxRejection?.find((paxRejection) => paxRejection?.type === "departurePax");
        if (props?.job?.rejectedPax == true || props?.job?.originalBookingDoc?.rejectedPax == true || props?.job?.rejectedALTPax == true || isRejectedArrJourney || isRejectedDepJourney || isRejectedArrPax || isRejectedDepPax) setJobStatusLine("Rejected");

        else if (props.booking) {

            // its a booking so we need to check the status using the pax location
            let status = props?.job?.paxPositionInfo?.paxStatus || props?.job?.paxPositionInfo?.activity
            status = String(status).charAt(0).toUpperCase() + String(status).slice(1);
            setJobStatusLine(status);

        }
        else {
            const cardStatus = getTaskCardStatus(props?.job)

            setJobStatusLine(cardStatus?.status)
        }

        // check if the job has a location and set the color accordingly for checked in
        if (props?.job?.paxPositionInfo?.activity == 'Checked-in' && !props?.job?.assignedTime && Array.isFullArray(airportLocations)) {
            const locationId = props?.job?.paxPositionInfo?.locationId;

            // use location list to get location color
            const location = airportLocations?.find((location) => location['_id'] == locationId);
            const color = location?.color || 'green';
            setLocationColor(color);

        }

    }, [props?.job]);

    return (
        <div style={{ display: 'inline-flex', alignItems: 'center', flex: 1 }} data-tippy-content="Assistance Task Status">


            <div style={{ flex: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>

                {(props?.job?.paxPositionInfo?.activity == "Checked-in" && !props?.job?.assignedTime) || (props?.job?.originalBookingDoc?.paxPositionInfo?.paxStatus == "checkedIn" && !props?.job?.assignedTime) ?
                    <div style={{ backgroundColor: locationColor, boxShadow: `0 0 15px ${locationColor}, 0 0 30px ${locationColor}, 0 0 45px ${locationColor}`, width: Spacing.SCALE_6, height: Spacing.SCALE_6, }} className="glowing-circle"></div>
                    :
                    props?.job?.assignedTime || props?.job?.paxPositionInfo ?
                        <div style={{ width: Spacing.SCALE_6, height: Spacing.SCALE_6, borderRadius: 25, backgroundColor: getJobStatusColor(props?.job) }} />
                        : null
                }
            </div>

            <div style={{ flex: 6 }}>
                <p style={{ margin: "0px", textAlign: "center", fontSize: 10, color: props?.job?.paxPositionInfo?.activity == "Checked-in" ? locationColor : getJobStatusColor(props?.job), fontWeight: "700" }}>{props?.job?.paxPositionInfo?.activity == "Checked-in" ? 'Checkedin' : jobStatusLine}</p>
            </div>
        </div>
    );
};

export default JobStatus;
